import React from "react";
import Book from "./components/Book";
import "./App.css";

function App() {
  return (
    <div className="container">
      <Book />
    </div>
  );
}

export default App;
